import * as services from 'services/catalogos.service';
import * as types from 'constants/catalogoMIActionTypes';
import { showAlert } from 'actions/alert.actions';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { ERROR_SAVE } from 'constants/MensajesGenerales';

export const getCatalogoMI = () => async (dispatch) => {
  dispatch({ type: types.GET_LIST_CATALOG_MI_LOADING });
  try {
    const response = await services.fetchCatalogoMediosImpresos();
    dispatch({ type: types.GET_LIST_CATALOG_MI_SUCCESS, payload: response.data.catalogo_medidas });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_LIST_CATALOG_MI_FAILURE, error });
    return { success: false, response: error };
  }
};

export const updateCatalogoMI = (data) => async (dispatch) => {
  dispatch({ type: types.UPDATE_CATALOG_MI_LOADING });
  try {
    const response = await services.updateCatalogoMediosImpresos(data);
    if (response.data.tipoMedida.synced[0].code !== 200) {
      const errorMessage = ERROR_SAVE;
      dispatch({ type: types.UPDATE_CATALOG_MI_FAILURE, error: { message: errorMessage } });
      dispatch(showAlert(errorMessage, ALERT_ERROR_TYPE));
      return { success: false };
    }
    dispatch({ type: types.UPDATE_CATALOG_MI_SUCCESS, payload: response.data.catalogo_medidas });
    dispatch(getCatalogoMI());
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.UPDATE_CATALOG_MI_FAILURE, error });
    return { success: false, response: error };
  }
};
